import { ForwardedRef, forwardRef } from "react"

import { ComponentProps } from "."
import { BluBlocksSelect } from "./styled"

const Select = forwardRef(
  (props: ComponentProps, ref: ForwardedRef<HTMLInputElement>) => (
    <BluBlocksSelect {...props} ref={ref} />
  )
)

Select.displayName = "Select"

export default Select
